export enum RepertoireStatus {
    ADDED = "added",
    LEARNING = "learning",
    POLISHING = "polishing",
    READY = "ready",
    MAINTENANCE = "maintenance",
    ARCHIVED = "archived",
}

export const repertoireStatusLabel: Record<RepertoireStatus, string> = {
    [RepertoireStatus.ADDED]: "Added",
    [RepertoireStatus.LEARNING]: "Learning",
    [RepertoireStatus.POLISHING]: "Polishing",
    [RepertoireStatus.READY]: "Performance ready",
    [RepertoireStatus.MAINTENANCE]: "Maintenance",
    [RepertoireStatus.ARCHIVED]: "Archived",
};


export enum Period {
    EARLY = "early",
    BAROQUE = "baroque",
    CLASSICAL = "classical",
    ROMANTIC = "romantic",
    MODERN = "modern"
}

export const periodLabel: Record<Period, string> = {
    [Period.EARLY]: "early",
    [Period.BAROQUE]: "baroque",
    [Period.CLASSICAL]: "classical",
    [Period.ROMANTIC]: "romantic",
    [Period.MODERN]: "modern"
}